export const GRID_DATE_PICKER_POPPER_CLASS = 'fim3-grid-date-picker-popper';
